import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Output,
    Renderer2,
} from '@angular/core';

@Directive({
    selector: '[datiqTruncate]',
})
export class DatiqTruncateDirective {
    ellipsed = false;
    @Output() datiqTruncateEllipsed: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    constructor(private _el: ElementRef, private _render: Renderer2) {}

    @HostListener('mouseover') onMouseOver() {
        const target: HTMLElement = this._el.nativeElement || {
            offSetWidth: 0,
            scrollWidth: 0,
        };
        const isEllipsed = target.offsetWidth < target.scrollWidth;

        this.datiqTruncateEllipsed.emit(isEllipsed);
    }

    @HostListener('click') onClick() {
        const target: HTMLElement = this._el.nativeElement || {
            offSetWidth: 0,
            scrollWidth: 0,
        };
        const isEllipsed = target.offsetWidth < target.scrollWidth;

        this.datiqTruncateEllipsed.emit(isEllipsed);
    }
}
